import React from "react"
import { withTranslation } from "react-i18next"
import { Spin } from 'antd'
import common from '@/asserts/js/common'
import { 
  dropUpOnLightImg,
  dropUpOnImg,
  dropUpImg,
  dropDownImg,
  dropDownOnImg,
  dropDownOnLightImg
} from '@/asserts/imgs/common/index'
import PaginationCon from '../Pagination/index'
import Mobile from '../Mobile'
import InputCon from '../InputCon/index'
import APPstyles from '@/App.less'
import styles from '@/pages/Account/index.less'
import myStyles from './index.less'

let leftConW=878,chgPage=1

class TodayDeal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      history:[],
      isLoading:true,
      country_code:'US',
      page:1,
      stock_id:null,
      sizeTotal:0,
      recperpage:20,
      isonLoadShow:true,
      dropDownL:0,
      dropDownR:'unset',
      dropDownT:38,
      dropDownW:'100%',
      loadMore:false,
      noMore:false,
      chgSort:'time_desc',
      onLoad:true,
      isSortShow:false
    }
    this.myTDRef = React.createRef()
  }
  //排序
  sortClick(name,tag,sortName){
    const {sortData,isTablet,ChgThemeData}=this.props
    const {country_code,stock_id,page,history,onLoad,chgSort,isLoading,isSortShow}=this.state
    if(history.length<=0||(!onLoad&&chgSort==tag)||isLoading) return
    this.setState({
      isLoading: true,
      chgSort:tag,
      onLoad:false,
      loadMore:false,
      noMore:false,
      isSortShow:!isSortShow
    })
    let newData=common.getSortDataFun(sortData,ChgThemeData,name,sortName)
    chgPage=1
    let chgPn=isTablet?1:page
    this.getTableData(country_code,stock_id,tag,chgPn,[])
    this.props.cbChgSortDataFun(newData)
  }
  //获取数据API
  getTableData(country_code,stock_id,sort,page,listsData) {
    const {isonLoadShow,recperpage}=this.state
    fetch(common.getHttpZs+"getTodayDeal", {
      method: "POST",
      headers: {
        Accept: "application/json,text/plain,*/*",
        "Content-Type": "application/json",
      },
      body:JSON.stringify({
        country_code: country_code,
        stock_id: stock_id,
        recperpage:recperpage,
        page: page,
        sort:sort, 
        token: sessionStorage.getItem("token")
      })
    })
    .then((res) => res.json())
    .then((result) => {
      if(result['status']==0){
        if(JSON.stringify(result['data']) !== '{}'){
          let size_total=result['data']['size_total']
          let datalist=result['data']['datalist']
          let getRicData=[]
          // 初始化执行
          if(isonLoadShow){
            this.setState({
              isonLoadShow: false
            })
            this.getTabNumData(size_total)
          }
          if(datalist.length){
            for(let i in datalist){
              getRicData.push(datalist[i]['stock_id'])
            }
            if(getRicData.length==datalist.length){
              getRicData= [...new Set(getRicData)]//去重
              this.getsimplequoteFun(getRicData,datalist,listsData,page,size_total)
            }
            return
          }
          if(listsData.length){
            this.setState({
              isLoading:false,
              loadMore:false,
              noMore:true
            })
          }else{
            this.noDataFun()
          }
          return
        }
        this.noDataFun()
        return
      }
      //获取失败
      this.noDataFun()
    })
  }
  //getsimplequote--获取数据
  getsimplequoteFun(ric,datalist,listsData,page,size_total){
    fetch(common.getHttp+'getsimplequote',{
      method:'POST',
      headers:{
        'Accept':'application/json,text/plain,*/*',
        'Content-Type':'application/json'
      },
      body:JSON.stringify({
        token:sessionStorage.getItem('token'),
        ric:ric 
      })
    })
    .then((response) => {
      if(response.ok){
        return response.text()        
      }
      throw new Error('Something went wrong.')
    })
    .then(res => {
      //获取数据成功
      res=JSON.parse(res)
      if(res['status']==0){
        let resData=res['data']
        if(JSON.stringify(resData)!=='{}'){
          for(let i in datalist){
            for(let j in ric){
              if(datalist[i]['stock_id']==ric[j]){
                let data=resData[ric[j]]
                datalist[i]['stock_code']=data['symbol']
                datalist[i]['stock_name']=data['name']
                datalist[i]['country']=data['exchange_country_code']
              }
            }
          }
          this.commonDataFun(datalist,listsData,page,size_total)
          return
        }
        this.noDataFun()
        return
      }
      //获取失败
      this.noDataFun()
    })
    .catch((err) => {
      console.log('Request failed', err)
      this.commonDataFun(datalist,listsData,page,size_total)
    })
  }
  commonDataFun(datalist,listsData,page,size_total){
    const {isTablet}=this.props
    let pn1=datalist.length?datalist.length>=10?false:true:false
    let pnother=listsData.length?datalist.length?false:true:true
    let noMoreData=page==1?pn1:pnother
    this.setState({
      history: isTablet?listsData.concat(datalist):datalist,
      sizeTotal:size_total,
      isLoading:false,
      loadMore:false,
      noMore:noMoreData
    })
  }
  // 获取失败
  noDataFun(){
    this.setState({
      history: [],
      sizeTotal:0,
      isLoading:false,
      loadMore:false,
      noMore:false
    })
  }
  //获取数据API--显示在tab栏的数据
  getTabNumData(size_total) {
    fetch(common.getHttpZs+"getNavTotal", {
      method: "POST",
      headers: {
        Accept: "application/json,text/plain,*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: sessionStorage.getItem("token"),
        tab:3
      })
    })
    .then((res) => res.json())
    .then((result) => {
      if(result['status']==0){
        let portfolio=result['data']['total_count']['portfolio']
        let today_order=result['data']['total_count']['today_order']
        let data=[portfolio,today_order,size_total]
        this.props.callbackTabNumData(data)
        return
      }
    })
  }
  //回传数据--input
  callbackInputData(data){
    const {chgSort}=this.state
    this.setState({
      isLoading:true,
      stock_id:data[0],
      country_code:data[1],
      page:1
    })
    chgPage=1
    this.getTableData(data[1],data[0],chgSort,1,[])
  }
  //回传数据--分页
  callbackPagekData(page){
    const {country_code,stock_id,chgSort}=this.state
    this.setState({
      isLoading:true,
      page:page
    })
    this.getTableData(country_code,stock_id,chgSort,page,[])
  }
  //更改下拉框
  changeDropDownData(){
    const {isPC}=this.props
    // 分页
    let contentId=document.getElementById('contentId').clientWidth
    let pageW=document.getElementById('pageId').clientWidth
    leftConW=contentId-pageW>878?878:'auto'

    this.setState({
      dropDownT: 38,
      dropDownL: isPC?8:0,
      dropDownW: isPC?'98%':'100%'
    })
  }
  //滚动加载更多--isTablet/mobile
  cbChgDataFun(){
    const {loadMore,noMore,isLoading,country_code,stock_id,history,chgSort}=this.state
    if(loadMore||noMore||isLoading) return
    chgPage++
    this.setState({
      page: chgPage,
      loadMore:true,
      noMore:false
    })
    this.getTableData(country_code,stock_id,chgSort,chgPage,history)
  }
  // 监听组件传递的值
  componentDidUpdate(newProps){
    const {bodyW,isSearchPageShow}=this.props
    if(bodyW!==newProps['bodyW']||isSearchPageShow!==newProps['isSearchPageShow']){
      this.changeDropDownData()
    }
  }
  //初始化
  componentDidMount() {
    const {country_code,stock_id,page,chgSort}=this.state
    chgPage=1
    this.setState({
      page: 1,
      loadMore:false,
      noMore:false
    })
    this.getTableData(country_code,stock_id,chgSort,page,[])
    this.changeDropDownData()
  }
  render() {
    const { t,ChgThemeData,ChgLangData,isPC,isTablet,sortData,isSearchPageShow} = this.props
    const {history,isLoading,sizeTotal,recperpage,page,dropDownL,dropDownR,dropDownT,dropDownW,loadMore,noMore,isSortShow} = this.state
    return (
      <div
        className={[
          styles.account_layout,
          isPC&&isSearchPageShow?'':APPstyles.flex1_auto,
          isPC&&isSearchPageShow||isTablet?APPstyles.flex_column:'',
          isPC&&isSearchPageShow||isTablet?APPstyles.hPer_overflowH:'',
          isPC&&isSearchPageShow?'':isPC?Math.ceil(sizeTotal / recperpage)>1?APPstyles.paddingBottom30:history.length?APPstyles.paddingBottom40:'':''
        ].join(' ')}
        style={{
          position:'relative'
        }}
      >
        {/* Header */}
        <div 
          id='contentId'
          className={[
            myStyles.header_con,
            APPstyles.flex_row,APPstyles.flex_between,
            ChgThemeData=='Light'?APPstyles.borderBottom_light:APPstyles.borderBottom_dark
          ].join(' ')} 
          style={{
            margin:isPC?'0 16px':0,
            padding:isPC?0:'0 16px'
          }}
        >
          <div 
            className={APPstyles.flex_1}
            style={{
              position:'relative',
              padding:isPC?'0 8px':0,
              width:isPC?leftConW:'auto',
              maxWidth:isPC?leftConW:'unset'
            }}
          >
            <InputCon
              {...this.props}
              dropDownL={dropDownL}
              dropDownR={dropDownR}
              dropDownT={dropDownT}
              dropDownW={dropDownW}
              callbackInputData={this.callbackInputData.bind(this)}
            />
          </div>
          {/* 分页 */}
          <div id='pageId' style={{display:isPC?'':'none',marginRight:16}}>
            <PaginationCon
              {...this.props}
              sizeTotal={sizeTotal}
              recperpage={recperpage}
              page={page}
              isShow={false}
              history={history}
              callbackPagekData={this.callbackPagekData.bind(this)}
            />
          </div>
        </div>
        {
          isPC?
            <div
              className={[
                isPC&&isSearchPageShow?APPstyles.flex1_auto:'',
                isPC&&isSearchPageShow?isPC?Math.ceil(sizeTotal / recperpage)>1?APPstyles.paddingBottom30:history.length?APPstyles.paddingBottom40:'':'':''
              ].join(' ')}
            >
              {/* header */}
              <div
                className={[
                  APPstyles.flex_row,
                  styles.account_header,
                  styles.header_pc,
                  styles.account_common,
                  styles.account_common_todaydeal,
                  ChgThemeData=='Light'?APPstyles.borderBottom_light:APPstyles.borderBottom_dark,
                  ChgLangData=='zh-CN'?styles.account_common_zhcn:'',
                  ChgLangData=='zh-CN'?APPstyles.fz12_zhcn:''
                ].join(" ")}
              >
                <div>
                  {t("Time")}
                  <div 
                    className={[
                      APPstyles.upDown_con,
                      APPstyles.flex_column
                    ].join(' ')}
                  >
                    <div 
                      className={APPstyles.img_dropdown_up}
                      onClick={()=>{this.sortClick('time','time_asc','asc')}}
                      onMouseOver={()=>{
                        if(!isPC) return
                        let imgurl=ChgThemeData=='Light'?dropUpOnLightImg:dropUpOnImg
                        sortData[0]['upImg']=imgurl
                        this.props.cgChgSortDataFun(sortData)
                      }} 
                      onMouseOut={()=>{
                        if(!isPC) return
                        let imgurl=sortData[0]['sortKey']=='asc'?ChgThemeData=='Light'?dropUpOnLightImg:dropUpOnImg:dropUpImg
                        sortData[0]['upImg']=imgurl
                        this.props.cgChgSortDataFun(sortData)
                      }}
                    >
                      <img src={sortData[0]['upImg']} />
                    </div>
                    <div 
                      className={APPstyles.img_dropdown_down} 
                      onClick={()=>{this.sortClick('time','time_desc','desc')}}
                      onMouseOver={()=>{
                        if(!isPC) return
                        let imgurl=ChgThemeData=='Light'?dropDownOnLightImg:dropDownOnImg
                        sortData[0]['downImg']=imgurl
                        this.props.cgChgSortDataFun(sortData)
                      }} 
                      onMouseOut={()=>{
                        if(!isPC) return
                        let imgurl=sortData[0]['sortKey']=='desc'?ChgThemeData=='Light'?dropDownOnLightImg:dropDownOnImg:dropDownImg
                        sortData[0]['downImg']=imgurl
                        this.props.cgChgSortDataFun(sortData)
                      }}
                    >
                      <img src={sortData[0]['downImg']} />
                    </div>
                  </div>
                </div>
                <div style={{width:'6%'}}>
                  {t("Direction")}
                  <div 
                    className={[
                      APPstyles.upDown_con,
                      APPstyles.flex_column
                    ].join(' ')}
                  >
                    <div 
                      className={APPstyles.img_dropdown_up} 
                      onClick={()=>{this.sortClick('direction','direction_asc','asc')}}
                      onMouseOver={()=>{
                        if(!isPC) return
                        let imgurl=ChgThemeData=='Light'?dropUpOnLightImg:dropUpOnImg
                        sortData[1]['upImg']=imgurl
                        this.props.cgChgSortDataFun(sortData)
                      }} 
                      onMouseOut={()=>{
                        if(!isPC) return
                        let imgurl=sortData[1]['sortKey']=='asc'?ChgThemeData=='Light'?dropUpOnLightImg:dropUpOnImg:dropUpImg
                        sortData[1]['upImg']=imgurl
                        this.props.cgChgSortDataFun(sortData)
                      }}
                    >
                      <img src={sortData[1]['upImg']} />
                    </div>
                    <div 
                      className={APPstyles.img_dropdown_down} 
                      onClick={()=>{this.sortClick('direction','direction_desc','desc')}}
                      onMouseOver={()=>{
                        if(!isPC) return
                        let imgurl=ChgThemeData=='Light'?dropDownOnLightImg:dropDownOnImg
                        sortData[1]['downImg']=imgurl
                        this.props.cgChgSortDataFun(sortData)
                      }} 
                      onMouseOut={()=>{
                        if(!isPC) return
                        let imgurl=sortData[1]['sortKey']=='desc'?ChgThemeData=='Light'?dropDownOnLightImg:dropDownOnImg:dropDownImg
                        sortData[1]['downImg']=imgurl
                        this.props.cgChgSortDataFun(sortData)
                      }}
                    >
                      <img src={sortData[1]['downImg']} />
                    </div>
                  </div>
                </div>
                <div 
                  style={{
                    width:'5%'
                  }}
                >
                  {t("Country")}
                </div>
                <div>{t("Code")}</div>
                <div 
                  className={styles.account_name}
                  style={{
                    width:'47%'
                  }}
                >
                  {t(ChgLangData == "zh-CN" ? "name" : "Name")}
                </div>
                <div style={{ justifyContent: "flex-end"}}>
                  {t("Order Price")}
                </div>
                <div style={{ justifyContent: "flex-end"}}>{t("QTY Filled1")}</div>
                <div style={{ justifyContent: "flex-end"}}>
                  {t("Total Amount")}
                </div>
                <div>{t("Order Type")}</div>
              </div>
              {/* body */}
              <div 
                className={history.length>0?'':APPstyles.minH300}
                style={{
                  position:!history.length&&!isLoading?'relative':'unset'
                }}
              >
                {/* 加载中 */}
                <div className={APPstyles.isLoading}><Spin spinning={isLoading} /></div>
                {
                  history.length>0?

                  history.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className={[
                            APPstyles.flex_row,
                            styles.account_body,
                            styles.account_common,
                            styles.account_common_todaydeal,
                            ChgThemeData=='Light'?APPstyles.borderBottom_light:APPstyles.borderBottom_dark,
                            ChgThemeData=='Light'?APPstyles.bg_event_light:APPstyles.bg_1b1b1b_hover,
                            ChgThemeData=='Light'?styles.account_body_light:'',
                            ChgLangData=='zh-CN'?styles.account_common_zhcn:''
                          ].join(" ")}
                        >
                          <div className={ChgThemeData=='Light'?APPstyles.color_theme_black:APPstyles.color_white}>{common.onlyOrderTime(item['time'])}</div>
                          <div 
                            className={item['direction'] == "B" ?APPstyles.color_red:APPstyles.color_green}
                            style={{
                              width:'6%' 
                            }}
                          >
                            {t(item['direction']=='B'?'Buy':item['direction']=='S'?'Sell':' ')}
                          </div>
                          <div
                           className={ChgThemeData=='Light'?APPstyles.color_theme_black:APPstyles.color_white}
                            style={{
                              width:'5%' 
                            }}
                          >
                            {t(common.valToUpperCase(item['country']))}
                          </div>
                          <div className={[ChgThemeData=='Light'?APPstyles.color_theme_black:APPstyles.color_white,APPstyles.fw700].join(' ')}>{common.valToUpperCase(item['stock_code'])}</div>
                          <div
                            style={{
                              width:'47%'
                            }}
                            className={[ChgThemeData=='Light'?APPstyles.color_009E9C:APPstyles.color_cur,styles.account_name].join(' ')}
                          >
                            {common.valToUpperCase(item['stock_name'])}
                          </div>
                          <div
                            className={ChgThemeData=='Light'?APPstyles.color_theme_black:APPstyles.color_white}
                            style={{
                              justifyContent: "flex-end"
                            }}
                          >
                            {common.transThousands(common.filterErro(item['order_price']))}
                          </div>
                          <div style={{ justifyContent: "flex-end"}}>{common.transThousands(common.keepNum(item['qty_filled'],0))}</div>
                          <div
                            className={ChgThemeData=='Light'?APPstyles.color_theme_black:APPstyles.color_white}
                            style={{
                              justifyContent: "flex-end"
                            }}
                          >
                            {common.transThousands(common.keepNum(item['total_amount'],2))}
                          </div>
                          <div className={ChgThemeData=='Light'?APPstyles.color_theme_black:APPstyles.color_white} style={{ textAlign: "right" }}>
                            {t(
                              item['order_type']==0?
                                'Limit Order'
                              :item['order_type']==50?
                                'Stop Limit'
                              :item['order_type']==4?
                                'Market Order1'
                              :
                                ''
                            )}
                          </div>
                        </div>
                      );
                    })
                    :
                    <div className={APPstyles.isLoading} style={{display:isLoading?'none':''}}>{t('No datas')}</div>  
                }
              </div>
            </div>
          :
          // 移动端
          <Mobile 
            {...this.props}
            history={history}
            changeName={ChgLangData == "zh-CN" ? "name" : "Name"}
            isLoading={isLoading}
            loadMore={loadMore}
            noMore={noMore}
            sizeTotal={sizeTotal}
            recperpage={recperpage}
            page={page}
            isShow={true}
            isSortShow={isSortShow}
            sortClick={this.sortClick.bind(this)}
            cbChgDataFun={this.cbChgDataFun.bind(this)}
          />  
        }
        {/* 分页 */}
        <div style={{display:isPC&&!isSearchPageShow?'':'none'}}>
        <PaginationCon
          {...this.props}
          sizeTotal={sizeTotal}
          recperpage={recperpage}
          page={page}
          isShow={true}
          history={history}
          callbackPagekData={this.callbackPagekData.bind(this)}
        />
        </div>
      </div>
    );
  }
}
export default withTranslation()(TodayDeal)
